var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"bookmark-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 26","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"fill-rule":"evenodd","stroke-linejoin":"round","d":"M1 1v24l8.502-6.473L18 25V1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }